import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Text } from 'UI';

const OperationHeader = ({ title }: { title: string }) => {
  const { t } = useTranslation();
  return (
    <Flex direction={'column'} size={0} minWidth={512} maxWidth={512} gap={25} padding={'20px 0'}>
      <Flex direction={'column'} gap={15}>
        <Text type="heading4" transform={'capitalize'} disableGutter>
          {title}
        </Text>
        <Text type="base">
          {t(
            'catalog.easy_basket.tab.parts_selection.description',
            'Our recommendations are already selected. If several options are available, you will have to make your choice.',
          )}
        </Text>
      </Flex>
    </Flex>
  );
};

export default OperationHeader;
